<template>
  <v-card wrap>
    <v-card-title primary-title style="display: flex; align-items: center; justify-content: space-between">
      <h2>Statistics - By Player</h2>
    </v-card-title>
    <v-card-title style="display: flex; align-items: center; justify-content: flex-end; padding: 0 16px">
      <v-select
        style="margin-right: 20px; width: 20%; flex: inherit"
        v-model="selectedCountry"
        :items="countrySelector"
      ></v-select>
      <v-select
        style="margin-right: 20px; width: 20%; flex: inherit"
        v-model="selectedType"
        :items="typeSelector"
      ></v-select>
      <v-select
        style="width: 15%; flex: inherit"
        v-model="selectedSet"
        :items="setSelector"
      ></v-select>
    </v-card-title>
    <v-container>

      <best-scorer v-if="selectedType === 1" :statistics="countryFiltered(statisticsFiltered)"></best-scorer>
      <best-spiker v-if="selectedType === 2" :statistics="countryFiltered(statisticsFiltered)"></best-spiker>
      <best-blocker v-if="selectedType === 3" :statistics="countryFiltered(statisticsFiltered)"></best-blocker>
      <best-server v-if="selectedType === 4" :statistics="countryFiltered(statisticsFiltered)"></best-server>
      <best-setter v-if="selectedType === 5" :statistics="countryFiltered(statisticsFiltered)"></best-setter>
      <best-digger v-if="selectedType === 6" :statistics="countryFiltered(statisticsFiltered)"></best-digger>
      <best-receiver v-if="selectedType === 7" :statistics="countryFiltered(statisticsFiltered)"></best-receiver>

    </v-container>
  </v-card>
</template>

<script>
import _ from 'lodash'

import BestScorer from './BestScorer'
import BestSpiker from './BestSpiker'
import BestBlocker from './BestBlocker'
import BestServer from './BestServer'
import BestSetter from './BestSetter'
import BestDigger from './BestDigger'
import BestReceiver from './BestReceiver'

export default {
  props: ['teams', 'statistics', 'statistics-per-set'],

  components: {
    'best-scorer': BestScorer,
    'best-spiker': BestSpiker,
    'best-blocker': BestBlocker,
    'best-server': BestServer,
    'best-setter': BestSetter,
    'best-digger': BestDigger,
    'best-receiver': BestReceiver,
  },

  data: () => ({
    selectedCountry: -1,
    countrySelector: [
      { text: 'Both Teams', value: -1 },
    ],
    selectedType: 1,
    typeSelector: [
      { text: 'Best Scorers', value: 1 },
      { text: 'Best Attackers', value: 2 },
      { text: 'Best Blockers', value: 3 },
      { text: 'Best Servers', value: 4 },
      { text: 'Best Diggers', value: 6 },
      { text: 'Best Receivers', value: 7 },
    ],
    selectedSet: -1,
    setSelector: [],
  }),

  created () {
    this.refreshSetSelector()

    for (let team in this.teams) {
      this.countrySelector.push({ text: this.teams[team].name, value: this.teams[team].code })
    }
  },

  computed: {
    statisticsFiltered () {
      if (this.selectedSet === -1) {
        return this.statistics
      }

      return this.statisticsPerSet[this.selectedSet]
    },
  },

  watch: {
    statisticsPerSet () {
      this.refreshSetSelector()
    },
  },

  methods: {
    refreshSetSelector () {
      this.setSelector = [
        { text: 'All Sets', value: -1 },
        { text: 'Set 1', value: 0 },
      ]

      this.statisticsPerSet.forEach((set, index) => {
        this.setSelector.push({ text: `Set ${index + 1}`, value: index })
      })
    },

    countryFiltered (statistics) {
      if (this.selectedCountry === -1) {
        return statistics
      }

      return statistics.filter((stat) => {
        return stat.teamCode === this.selectedCountry
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MatchLive/StatisticsByPlayer/StatisticsByPlayer.vue